import { Component } from '@angular/core';

import { StorageService } from './services/StorageService';
// import { TranslateService } from '@ngx-translate/core';
// import Swal from 'sweetalert2';
// import { UpToDateBuildService } from './helpers/BuildDetails/up-to-date.service';
import { Directionality } from '@angular/cdk/bidi';
import packageJson from '../../package.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {
  title = 'App-Management';
  public version: string = packageJson.version;

  constructor(
    public storageService: StorageService,
    // private translate: TranslateService,
    private appDir: Directionality
    // upToDateService: UpToDateBuildService
  ) {
    // let buildNumber = upToDateService.buildNumberAtStartup;
    // upToDateService.buildIsUpToDate.subscribe(buildIsUpToDate => {
    //   if (!buildIsUpToDate) {
    //     Swal.fire({
    //       title: this.translate.instant('general.New app version found.'),
    //       icon: 'info',
    //       confirmButtonText: this.translate.instant('swalMsg.Reload'),
    //     }).then(() => {
    //       window.location.reload();
    //     });
    //   }
    // });

    this.storageService.changes.subscribe(data => {
      if (data?.key == 'language' || data?.key == 'authUser') {
        localStorage.removeItem('orders');
        localStorage.removeItem('takeawarOrder');
        window.location.reload();
      }
    });

    var lang = localStorage.getItem('language') || 'en';
    localStorage.setItem('language', lang);
    var style = './assets/css/en-US/style.css';
    var dir = 'ltr';
    if (lang == 'ar') {
      style = './assets/css/ar-SA/style.css';
      dir = 'rtl';
    }
    let buildNumber = this.version;
    style += buildNumber ? '?vr=' + buildNumber : '';
    document.getElementById('mainStyle')?.setAttribute('href', style);
    document.getElementById('html')?.setAttribute('lang', lang);
    document.getElementById('html')?.setAttribute('dir', dir);
    (this.appDir as any).value = dir;
  }
}
